// extracted by mini-css-extract-plugin
export var content = "_5w-3";
export var list = "_5w-4";
export var settingsContent = "_5w-7";
export var settingsPanel = "_5w-8";
export var state = "_5w-6";
export var triggerBadge = "_5w-2";
export var triggerButton = "_5w-1";
export var triggerShell = "_5w-0";
export var unreadDot = "_5w-5";